export default function formatDurationFromSeconds(seconds: number) {
  if (seconds < 0) {
    throw new Error("The number of seconds must be greater than or equal to 0");
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedHours = hours > 0 ? `${hours}h${minutes}m` : "";
  const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
  const formattedSeconds = `${remainingSeconds}s`;

  return formattedHours || formattedMinutes || formattedSeconds;
}
